import { Reducer } from "redux";

import { DocumentSourceResponse } from "../models/Api/Master";
import { DocumentSourceDispatchTypes } from "../models/DispatchTypes/Master";
import { DocumentSourceActionDispatchTypes } from "../constants/Master";
import { setLocalStorageData } from "../utils";

const initialState: DocumentSourceResponse = {
  loading: false,
  response: [],
};

const DocumentSourceReducer: Reducer<
  DocumentSourceResponse,
  DocumentSourceDispatchTypes
> = (state = initialState, action) => {
  switch (action.type) {
    case DocumentSourceActionDispatchTypes.GET_DOCUMENT_SOURCE_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case DocumentSourceActionDispatchTypes.GET_DOCUMENT_SOURCE_SUCCESS: {
      setLocalStorageData(
        DocumentSourceActionDispatchTypes.GET_DOCUMENT_SOURCE_SUCCESS,
        action.response
      );
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case DocumentSourceActionDispatchTypes.GET_DOCUMENT_SOURCE_RESET: {
      return initialState;
    }
    case DocumentSourceActionDispatchTypes.GET_DOCUMENT_SOURCE_ERROR: {
      return initialState;
    }
  }
  return state;
};

export default DocumentSourceReducer;
